module.exports = function systemShortName (systemSlug) {
  let map = {
    'nintendo-wii-u': 'WiiU',
    'nintendo-wii': 'Wii',
    'nintendo-gamecube': 'NGC',
    'nintendo-64': 'N64',
    'super-nintendo': 'SNES',
    'nintendo-entertainment-system': 'NES',
    'nintendo-3ds': '3DS',
    'nintendo-ds': 'DS',
    'game-boy-advance': 'GBA',
    'game-boy-color': 'GBC',

    'game-boy': 'GB',
    'virtual-boy': 'VB',
    'xbox-360': 'X360',
    'xbox': 'Xbox',
    'playstation-3': 'PS3',
    'playstation-2': 'PS2',
    'playstation': 'PS',
    'playstation-vita': 'PSV',
    'playstation-portable': 'PSP',
    'sega-dreamcast': 'SD',

    'sega-saturn': 'SS',
    'sega-cd': 'SCD',
    'sega-32x': 'S32x',
    'sega-genesis': 'SG',
    'sega-master-system': 'SMS',
    'game-gear': 'GG',
    'atari-2600': '2600',
    'atari-5200': '5200',
    'atari-7800': '7800',
    'atari-jaguar': 'Jagu',

    'atari-lynx': 'Lynx',
    'xbox-one': 'XOne',
    'playstation-4': 'PS4',
    'sega-pico': 'SP',
    'neo-geo-aes': 'NGA',
    '3do-interactive-multiplayer': '3do',
    'turbografx-16': 'T16',
    'game.com': '.com',
    'intellivision': 'Intel',
    'game-and-watch': 'GAW',

    'turbografx-16-cd': 'T16CD',
    'nintendo-switch': 'Switch',
    'famicom-disk-system': 'FDS',
    'n-gage': 'NGAGE',
    'atari-jaguar-cd': 'AJCD',
    'microvision': 'Micro',
    'vectrex': 'VTRX',
    'magnavox-odyssey': 'MO',
    'nintendo-64dd': 'N64DD',
    'pc': 'pc'
  }

  return map[systemSlug]
}
